import { render, staticRenderFns } from "./TableDesign.vue?vue&type=template&id=9d927de6&scoped=true"
import script from "./TableDesign.vue?vue&type=script&lang=js"
export * from "./TableDesign.vue?vue&type=script&lang=js"
import style0 from "./TableDesign.vue?vue&type=style&index=0&id=9d927de6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d927de6",
  null
  
)

export default component.exports